import { API_URL } from "../config";
const API_BASE_URL = API_URL;

// 날씨 데이터 캐시 저장소
const weatherCache = {
  briefForecast: new Map(), 
  lastFetched: new Map(),   
  CACHE_DURATION: 60 * 60 * 1000, 
};

// 캐시 키 생성 함수
const getCacheKey = (position) => {
  const lat = position.lat.toFixed(3);
  const lng = position.lng.toFixed(3);
  return `${lat},${lng}`;
};

// 캐시 유효성 확인 함수
const isCacheValid = (key) => {
  if (!weatherCache.lastFetched.has(key)) return false;
  
  const lastFetchTime = weatherCache.lastFetched.get(key);
  const currentTime = Date.now();
  return (currentTime - lastFetchTime) < weatherCache.CACHE_DURATION;
};

// API 요청 추적을 위한 디버그 로그
const logRequest = (type, position, cached = false) => {
  console.log(`🌤️ ${type} 요청 [${cached ? '캐시' : '서버'}]: ${position.lat.toFixed(3)}, ${position.lng.toFixed(3)}`);
};

// API 요청 중복 방지를 위한 객체
const pendingRequests = {
  briefForecast: new Map(),
};

export const chatService = {
  sendMessage: async (message, history, position = null) => {
    
    const payload = { chat: message };
    if (position) {
      payload.lat = position.lat;
      payload.lng = position.lng;
    }
    
    const response = await fetch(`${API_BASE_URL}/weather`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    if (!response.ok) throw new Error('Failed to fetch weather');
    return await response.json();
  },
  
  getBriefForecast: async (position) => {
    if (!position || !position.lat || !position.lng) {
      throw new Error('Position data is required');
    }
    
    // 캐시 키 생성
    const cacheKey = getCacheKey(position);
    
    if (pendingRequests.briefForecast.has(cacheKey)) {
      console.log('📡 중복 요청 대기 중:', cacheKey);
      return pendingRequests.briefForecast.get(cacheKey);
    }
    
    if (weatherCache.briefForecast.has(cacheKey) && isCacheValid(cacheKey)) {
      logRequest('날씨', position, true);
      return weatherCache.briefForecast.get(cacheKey);
    }
    
    // 새로운 요청 생성하고 추적
    const requestPromise = (async () => {
      try {
        // 캐시에 없거나 만료되었으면 새로 요청
        logRequest('날씨', position, false);
        const response = await fetch(`${API_BASE_URL}/weather/brief`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            lat: position.lat,
            lng: position.lng
          })
        });
        
        if (!response.ok) throw new Error('Failed to fetch brief forecast');
        const data = await response.json();
        const forecast = data.forecast || '날씨 정보 없음';
        
        // 캐시 업데이트
        weatherCache.briefForecast.set(cacheKey, forecast);
        weatherCache.lastFetched.set(cacheKey, Date.now());
        
        return forecast;
      } finally {
        // 요청 완료 후 추적 목록에서 제거
        pendingRequests.briefForecast.delete(cacheKey);
      }
    })();
    
    // 진행 중인 요청 추적
    pendingRequests.briefForecast.set(cacheKey, requestPromise);
    
    return requestPromise;
  },
  
  clearWeatherCache: () => {
    weatherCache.briefForecast.clear();
    weatherCache.lastFetched.clear();
    console.log('날씨 캐시가 초기화되었습니다.');
  }
};